import $c from '@/services/api/lib/container'

export default {
  async loadOrder (id) {
    const order = await $c.get('order').find(id)
    await order.loadComments()
    await order.loadHoldReasons()
    return order
  }
}
